import React, { useState } from "react";
import LOGO from "../../assets/images/DERMASTER_NEW_LOGO.png";
import TextField from "../../components/textfield/textfield";
import Button from "../../components/button/Button";
import "../../assets/styles/index.scss";
import MainButton from "../../components/button/mainButton";
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Alert, message, Form, Input, Checkbox } from "antd";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setBearerToken } from "../../helpers/functions";

const LoginPage = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchUserInfo = async ({ user, token }: any) => {
    if (user._id) {
      // set token
      console.log("setting token =>", token);

      localStorage.setItem("token", token);

      // Add a request interceptor
      // const token = localStorage.getItem('token');
      // axios.interceptors.request.use(function (config: any) {
      //   config.headers.Authorization = `Bearer ${token}`;

      //   return config;
      // });

      setBearerToken(axios, false, token);

      const checkValueToken = localStorage.getItem("token");
      console.log("checkValueToken =>", checkValueToken);

      // await setInitialState((s) => ({
      //   ...s,
      //   currentUser: user,
      // }));
    }
  };

  const onFinish = async (values: any) => {
    console.log("values =>", values);

    if (!values.username && !values.password) {
      message.warning("กรุณาป้อนชื่อผู้ใช้งานและรหัสผ่าน!");
      return;
    } else if (!values.username) {
      message.warning("กรุณาป้อนชื่อผู้ใช้งาน!");
      return;
    } else if (!values.password) {
      message.warning("กรุณาป้อนรหัสผ่าน!");
      return;
    }

    try {
      setLoading(true);

      const body = { ...values };

      const { data }: any = await axios.post(`/auth/login`, body);
      console.log("data =>", data);

      const { user, token } = data;

      // setBearerToken(axios, false, token);

      message.success("เข้าสู่ระบบสำเร็จ!");

      await fetchUserInfo({ user, token });

      dispatch({
        type: "UPDATE_USER",
        data: user,
      });

      window.location.href = "/opd";

      // setTimeout(() => {
      //   console.log("go to opd...");
      //   history.push(`/opd`);
      // }, 1000);
    } catch (err: any) {
      message.warning("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง!");
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="container">
        <img className="logo" src={LOGO} alt="Dermaster" />
        <div className="box">
          <div className="box-contant">
            <Form
              name="normal_login"
              className="login-form"
              layout="vertical"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <label className="label">เข้าสู่ระบบ / Log in</label>
              <TextField name="username" placeholder="Username" width={300} />
              <TextField
                name="password"
                placeholder="Password"
                isPassword={true}
                width={300}
              />
              <div style={{ marginTop: "10px" }}></div>
              <MainButton
                title="LOGIN"
                to="/home"
                width="300px"
                background="#5BAEA9"
                isSubmit={true}
                loading={loading}
              />
              <div className="forgot-password">
                {/* <label>ลืมรหัสผ่าน?/Forgot password?</label> */}
                <Link to="/ForgotPassword">ลืมรหัสผ่าน?/Forgot password?</Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
